import script from "./AddLeadModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddLeadModal.vue?vue&type=script&setup=true&lang=js"

import "./AddLeadModal.vue?vue&type=style&index=0&id=48e306b9&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48e306b9"]])

export default __exports__